const Title = ({ children }) => {
  return <h6 className='mb-5 text-2xl font-bold capitalize'>{children}</h6>
}
export default Title
